/* eslint-disable react/prop-types */
import classes from "./content.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import { PROPERTY_PLACEHOLDER } from "@/common/announcement-helper";
function Content({ interventions, facilitation, incentive }) {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <Grid columns={isMobile ? "1fr" : "1fr 1fr"} className={classes.container}>
      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.column}
      >
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.content}
        >
          <Label
            tag="h6"
            align="start"
            color="secondary"
            weight="bold"
            className={classes.title}
          >
            Interventi ammissibili
          </Label>
          <Label tag="p" align="start" size="md" color="secondary">
            {interventions ? interventions : PROPERTY_PLACEHOLDER}
          </Label>
        </Flex>
      </Flex>

      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.column}
      >
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.content}
        >
          <Label
            tag="h6"
            align="start"
            color="secondary"
            weight="bold"
            className={classes.title}
          >
            Agevolazione
          </Label>
          <Label tag="p" align="start" size="md" color="secondary">
            {facilitation ? facilitation : PROPERTY_PLACEHOLDER}
          </Label>
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classes.content}
        >
          <Label
            tag="h6"
            align="start"
            color="secondary"
            weight="bold"
            className={classes.title}
          >
            Istruttoria
          </Label>
          <Label tag="p" align="start" size="md" color="secondary">
            {incentive ? incentive : PROPERTY_PLACEHOLDER}
          </Label>
        </Flex>
      </Flex>
    </Grid>
  );
}

export default Content;
